import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { selectUnderwriting } from './underwriting.selectors';

export const selectConditionSetsList = createSelector(selectUnderwriting, ({ conditionSets }) =>
  _.orderBy(Object.values(conditionSets), [({ name }) => _.toLower(name)]),
);

const selectConditionSets = createSelector(
  selectUnderwriting,
  ({ conditionSets }) => conditionSets,
);

export const selectConditionSetById = memoizeOne(id =>
  createSelector(selectConditionSets, conditionSets => conditionSets?.[id]),
);

export const selectFilteredConditionSets = createSelector(
  [getDebouncedSearchValue, selectConditionSetsList],
  searchItems(({ name }) => [name]),
);

export const selectConditionSetsNotEmpty = createSelector(selectConditionSetsList, conditionSets =>
  conditionSets.filter(({ links }) => !!links.length),
);

export const selectConditionSetsCsvData = createSelector(selectConditionSetsList, conditionSets =>
  conditionSets.map(({ name, links }) => {
    const conditionKeys = links.reduce((acc, { condition }, index) => {
      acc[`condition${index + 1}`] = condition.message;

      return acc;
    }, {});

    return { name, ...conditionKeys };
  }),
);
